import { InjectionToken } from '@angular/core';
import { CrudItemViewServiceCustom } from './crud-item-view-service-custom';
import { CrudFormServiceFactory } from '@common/crud/frontend-shared';
import { CrudServiceFactory } from '@core/frontend-shared';
export const CRUD_ITEM_VIEW_SERVICE_TOKEN = /*#__PURE__*/new InjectionToken("CrudItemViewService");
export function provideCrudItemViewServiceCustom(config) {
  return {
    provide: CRUD_ITEM_VIEW_SERVICE_TOKEN,
    useFactory: (crudServiceFactory, crudFormServiceFactory) => {
      return new CrudItemViewServiceCustom(config, crudServiceFactory, crudFormServiceFactory);
    },
    deps: [CrudServiceFactory, CrudFormServiceFactory]
  };
}